import { useSearchParams } from 'react-router-dom';
import { ppData } from '../configs/ppData.config';
export const useActiveVariant = (searchParams = useSearchParams()[0]) => {
    const activeValues = ppData.options.map(({ searchParamKey }) => searchParams.get(searchParamKey));
    return ppData.variants.find(({ optionValues }) => {
        return optionValues.every((value, i) => {
            return value === activeValues[i];
        });
    });
};
